import { ko } from 'date-fns/locale/ko';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { deleteMAIAA010, getMAIAA020DeMemberID, postMAIAA020, putMAIAA020 } from '../../../../services/Api';
import { MESSAGE } from '../../../../shared/constants/app';
registerLocale('ko', ko);

const MAIAA020 = ({ closePopup, dataPopup }) => {
    const purchaseDateRef = useRef();
    const [dataItem, setDataItem] = useState({});
    const today = moment().format('YYYY-MM-DD');
    const [date, setDate] = useState(today);
    const [readOnly, setReadOnly] = useState(false);
    const listOption = [
        { key: '000', value: '선택' },
        { key: '001', value: '덴탈잡채용광고' },
        { key: '011', value: '덴탈잡비즈니스배너' },
        { key: '002', value: '덴탈잡그랜드배너(채용광고포함)' },
        { key: '0023', value: '그랜드 배너 (채용광고 디자인 서비스 포함)' },
        { key: '003', value: '덴탈잡프리미엄배너(채용광고포함)' },
        { key: '0033', value: '프리미엄 배너 (채용광고 디자인 서비스 포함)' },
        { key: '008', value: '덴탈잡핫리쿠르트(채용광고포함)' },
        { key: '1000', value: '하이라이트강조' },
        { key: '1500', value: '하이라이트강조2' },
        { key: '2000', value: '컬러강조' },
        { key: '2500', value: '컬러강조2' },
        { key: '3000', value: '아이콘강조(이용권)' },
        { key: '3500', value: '아이콘강조2(이용권)' },
        { key: '4000', value: '핫리쿠르트배너고정옵션' },
        { key: '5000', value: '고정옵션' },
        { key: '6000', value: '그랜드배너고정옵션' },
        { key: '7000', value: '프리미엄배너고정옵션' },
    ];

    const listOptionTicketType = [
        { key: '', value: '멤버십증정' },
        { key: 'Y1', value: '사은품' },
        { key: 'Z1', value: '멤버십증정' },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'goodNameCode') {
            const selectedOption = listOption.find((option) => option.key === value);

            setDataItem((prevData) => ({
                ...prevData,
                [name]: selectedOption ? selectedOption : value,
            }));
            return;
        }
        setDataItem((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSave = () => {
        if (!dataItem.goodNameCode?.key) {
            window.alert('상품명 선택해 주세요.');
            return;
        }
        getMAIAA020DeMemberID(dataItem.deMemberID)
            .then((data) => {
                if (data.data === 1) {
                    if (dataPopup[0]) {
                        console.log(1);
                        putMAIAA020({
                            seq: dataPopup[0]?.seq || 0,
                            goodNameCode: dataItem.goodNameCode?.key || '000',
                            goodName: dataItem.goodNameCode?.value || '선택',
                            ticketType: dataItem?.ticketType || '',
                            comments: dataItem?.comments || '',
                        })
                            .then(() => {
                                window.alert(MESSAGE.notify.updateSuccess);
                                closePopup();
                            })
                            .catch((error) => {
                                console.log(error);
                                window.alert(MESSAGE.notify.updateError);
                            });
                    } else {
                        postMAIAA020({
                            deMemberID: dataItem.deMemberID,
                            goodNameCode: dataItem.goodNameCode?.key || '000',
                            goodName: dataItem.goodNameCode?.value || '선택',
                            purchaseDate: date || moment(date).format('YYYY-MM-DD'),
                            comments: dataItem?.comments || '',
                            ticketType: dataItem?.ticketType || '',
                        })
                            .then(() => {
                                window.alert(MESSAGE.notify.createSuccess);
                                closePopup();
                            })
                            .catch((error) => {
                                console.log(error);
                                window.alert(MESSAGE.notify.createError);
                            });
                    }
                } else {
                    window.alert('등록된 치과 회원 아이디가 아닙니다.');
                }
            })
            .catch((error) => console.log(error));
    };

    const handleDelete = (seq) => {
        deleteMAIAA010(seq)
            .then((data) => {
                window.alert(MESSAGE.notify.deleteSuccess);
                window.location.reload();
            })
            .catch((error) => {
                console.log(error);
                window.alert(MESSAGE.notify.deleteError);
            });
    };

    const handleDateChange = (date, name) => {
        const dateFormat = date ? moment(date).format('YYYY-MM-DD') : null;
        setDate(dateFormat);
    };

    useEffect(() => {
        setDataItem({ deMemberID: '' });
        setReadOnly(false);
        if (dataPopup[0]) {
            setDataItem({
                seq: dataPopup[0].seq,
                deMemberID: dataPopup[0].deMemberID,
                goodNameCode: {
                    key: dataPopup[0].goodNameCode || '000',
                    value: dataPopup[0].goodName || '선택',
                },
                purchaseDate: dataPopup[0].purchaseDate || moment(date).format('YYYY-MM-DD'),
                comments: dataPopup[0]?.comments || '',
                ticketType1: dataPopup[0]?.ticketType || '',
                ticketType: listOptionTicketType.find((item) => item.value === dataPopup[0].ticketType)?.key || '',
            });
            setReadOnly(true);
        }
        // eslint-disable-next-line
    }, []);

    return (
        <div id="content">
            <div className="container">
                <div id="popup" data-popup="issuance-individual-tickets">
                    <div className="overlay" />
                    <div className="popup-content">
                        <div className="popup-close" onClick={closePopup} />
                        <div className="popup-title">개별 이용권 발급</div>
                        <div className="form-group-tickets">
                            <div className="form-group-left">
                                <div className="title-form">덴탈비타민 ID</div>
                                <div className="title-form">상품명</div>
                                <div className="title-form">결제금액</div>
                                <div className="title-form">구매일자</div>
                                <div className="title-form">사은품구분</div>
                                <div className="title-form title-form-comments">Comments</div>
                            </div>
                            <div className="form-group-right">
                                <div className="item-form">
                                    <input
                                        type="text"
                                        value={dataItem?.deMemberID || ''}
                                        name="deMemberID"
                                        onChange={handleChange}
                                        style={{ width: 300 }}
                                        readOnly={readOnly}
                                    />
                                </div>
                                <div className="item-form">
                                    <div className="select-box">
                                        <select
                                            style={{ width: 300 }}
                                            name="goodNameCode"
                                            id="goodNameCode"
                                            onChange={handleChange}
                                            value={dataItem?.goodNameCode?.key || '000'}
                                        >
                                            {listOption.map((item, index) => (
                                                <option value={item.key} key={`option-${index}`}>
                                                    {item.value}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="item-form">
                                    <div className="payment-amount">상품명</div>
                                </div>
                                <div className="item-form">
                                    <div className="datepicker-child" style={{ margin: 0, width: 300 }}>
                                        <DatePicker
                                            ref={purchaseDateRef}
                                            className="w300"
                                            onChange={(date) => handleDateChange(date, 'purchaseDate')}
                                            locale={'ko'}
                                            placeholderText={'YYYY/MM/DD'}
                                            dateFormat={'yyyy/MM/dd'}
                                            selected={dataItem?.purchaseDate || date}
                                            maxDate={null}
                                        />
                                        <i
                                            className="icon icon-date"
                                            id="purchase-date-icon"
                                            onClick={() => purchaseDateRef.current.setFocus()}
                                        />
                                    </div>
                                </div>
                                <div className="item-form">
                                    <div className="select-box">
                                        <select
                                            className="w300"
                                            name="ticketType"
                                            id="ticketType"
                                            onChange={handleChange}
                                            value={dataItem?.ticketType}
                                        >
                                            <option value="">선택</option>
                                            <option value="Y1">사은품</option>
                                            <option value="Z1">멤버십증정</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="item-form">
                                    <textarea
                                        name="comments"
                                        id="content-form-comments"
                                        value={dataItem?.comments}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="group-button center">
                            <button className="popup-button" onClick={handleSave}>
                                {dataPopup[0] ? '이용권 수정' : '이용권 발급'}
                            </button>
                            {dataPopup[0] && (
                                <button className="popup-button" onClick={() => handleDelete(dataItem?.seq)}>
                                    이용권 삭제
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAIAA020;
